import Config from "../config.js";
import { createRequestOptions } from "./utils";
import { get } from "lodash";

export default () => {
  return Object.freeze({
    getAppEmailSettings: async (appId) => {
      const options = createRequestOptions({ appId });

      const result = await fetch(
        Config.serverUrl + "/GetAppEmailSettings",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    getOnboardinSettings: async (appId) => {
      const options = createRequestOptions({ appId });

      const result = await fetch(
        Config.serverUrl + "/GetOnboardingSettings",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    enableCustomEmail: async (appId, enabled) => {
      const options = createRequestOptions({ appId, enabled });

      const result = await fetch(
        Config.serverUrl + "/EnableCustomEmail",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    updateCustomEmailTemplate: async (appId, subject, emailIntro) => {
      const options = createRequestOptions({ appId, subject, emailIntro });

      const result = await fetch(
        Config.serverUrl + "/UpdateCustomEmailTemplate",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    requestWelcomeProgramAccess: async (appId) => {
      const options = createRequestOptions({ appId });

      const result = await fetch(
        Config.serverUrl + "/RequestWelcomeProgramAccess",
        options
      );

      const response = await result.json();

      return get(response, "response");
    },
  });
};



// WEBPACK FOOTER //
// ./src/services/appSettings.js